export const API_URL =
"https://ideoqoi3j4.execute-api.us-east-1.amazonaws.com/production/api";
// export const API_URL = "http://localhost:5000/api";

// mumbai region url
// export const API_URL =
//   "https://uvjay4br6k.execute-api.ap-south-1.amazonaws.com/production/api";
